import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const data = [
  { name: "Jan", sales: 400 },
  { name: "Feb", sales: 300 },
  { name: "Mar", sales: 500 },
  { name: "Apr", sales: 200 },
  { name: "May", sales: 600 },
];

const Dashboard = () => {
  return (
    <div className="flex flex-col h-full bg-white font-plus">
      {/* Global Dashboard Header */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center px-8 py-4 bg-white border-b border-gray-200 shrink-0">
        <div>
          <h1 className="text-[14px] font-black tracking-[4px] text-gray-900 uppercase mb-2">SYSTEM ANALYTICS HUB</h1>
          <p className="text-[11px] font-bold text-gray-400 uppercase tracking-[2px]">
            OPERATIONAL OVERVIEW PROTOCOL
            <span className="mx-3 text-gray-200">|</span>
            <span className="text-primary">ACTIVE SESSION IN PROGRESS</span>
          </p>
        </div>
        <div className="bg-primary text-white px-6 py-3 font-black text-[10px] tracking-[2px] uppercase">
          {new Date().toLocaleDateString(undefined, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }).toUpperCase()}
        </div>
      </div>

      {/* Main Content Area */}
      <div className="px-8 py-6 space-y-8 flex-1 overflow-y-auto">
        {/* Summary Metrics */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {[
            { label: "ACTIVE SALES ORDERS", value: "142", trend: "+12.5%", icon: "ORD" },
            { label: "PENDING DIE INWARDS", value: "18", trend: "-3", icon: "DIE" },
            { label: "EXTRUSION OUTPUT (KG)", value: "12,450", trend: "+8.2%", icon: "EXT" },
            { label: "MATERIAL RECEIPTS", value: "37", trend: "+5", icon: "STK" },
          ].map((stat, i) => (
            <div key={i} className="bg-white p-6 border border-gray-200 relative overflow-hidden group">
              <div className="absolute top-0 left-0 w-1 h-full bg-primary" />
              <div className="flex justify-between items-start mb-4">
                <h2 className="text-[9px] font-black text-gray-400 uppercase tracking-[2px]">{stat.label}</h2>
                <span className="text-[9px] font-black text-green-600 bg-green-50 px-2 py-0.5">{stat.trend}</span>
              </div>
              <div className="flex items-baseline gap-2">
                <p className="text-[24px] font-black text-gray-900">{stat.value}</p>
                <span className="text-[10px] font-bold text-gray-300 uppercase tracking-widest">{stat.icon}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Primary Analytics */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 pb-10">
          <div className="lg:col-span-2 bg-white p-8 border border-gray-200">
            <div className="flex justify-between items-center mb-8 border-b border-gray-50 pb-4">
              <h2 className="text-[11px] font-black text-gray-900 tracking-[3px] uppercase">
                OPERATIONAL PERFORMANCE MANIFEST
              </h2>
              <div className="flex gap-2">
                <div className="w-3 h-3 bg-primary mt-0.5" />
                <span className="text-[9px] font-black text-gray-400 uppercase tracking-widest">PERFORMANCE DELTA</span>
              </div>
            </div>
            <div className="w-full h-[320px]">
              <ResponsiveContainer width="100%" height="100%">
                <BarChart data={data} margin={{ top: 0, right: 0, left: -20, bottom: 0 }}>
                  <XAxis
                    dataKey="name"
                    stroke="#e2e8f0"
                    tick={{ fill: '#94a3b8', fontSize: 10, fontWeight: 900 }}
                    tickLine={false}
                    axisLine={false}
                  />
                  <YAxis
                    stroke="#e2e8f0"
                    tick={{ fill: '#94a3b8', fontSize: 10, fontWeight: 900 }}
                    tickLine={false}
                    axisLine={false}
                  />
                  <Tooltip
                    cursor={{ fill: '#f8fafc' }}
                    contentStyle={{
                      backgroundColor: '#3F80F7',
                      border: 'none',
                      borderRadius: '0px',
                      padding: '12px'
                    }}
                    itemStyle={{
                      color: 'white',
                      fontSize: '11px',
                      fontWeight: 900,
                      textTransform: 'uppercase',
                      letterSpacing: '1px'
                    }}
                    labelStyle={{ display: 'none' }}
                  />
                  <Bar dataKey="sales" fill="#3F80F7" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>

          <div className="bg-primary p-8 text-white relative overflow-hidden">
            <div className="absolute top-0 right-0 w-32 h-32 bg-white/5 -mr-16 -mt-16 rotate-45" />
            <h2 className="text-[11px] font-black tracking-[3px] uppercase mb-8 border-b border-white/10 pb-4">
              ACTIVITY REPOSITORY LOG
            </h2>
            <div className="space-y-6">
              {[
                { log: "SALES ORDER #882 APPROVED", time: "02:14 PM" },
                { log: "DIE #2041 INWARDED", time: "11:05 AM" },
                { log: "CASTING BATCH #C-492 QC PASSED", time: "09:42 AM" },
                { log: "NEW RAW MATERIAL RECEIVED", time: "08:15 AM" },
                { log: "FURNACE #2 HEATING COMPLETED", time: "YESTERDAY" },
              ].map((activity, i) => (
                <div key={i} className="flex flex-col border-l-2 border-white/20 pl-4 py-1">
                  <span className="text-[10px] font-black tracking-[1.5px] mb-1">{activity.log}</span>
                  <span className="text-[8px] font-bold text-white/40 uppercase tracking-widest">{activity.time}</span>
                </div>
              ))}
            </div>
            <button className="mt-12 w-full bg-white/10 hover:bg-white text-white hover:text-primary py-3 text-[9px] font-black tracking-[4px] uppercase border border-white/20 transition-all">
              EXPAND LOGS
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
